var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIconSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0057 19C8.07489 19.0013 6.20121 18.3452 4.693 17.1397C3.18479 15.9342 2.13193 14.2512 1.70771 12.3676C1.28349 10.484 1.5132 8.51206 2.35901 6.77641C3.20483 5.04075 4.61636 3.64478 6.36127 2.81824C8.10619 1.9917 10.0805 1.78385 11.9593 2.2289C13.8381 2.67396 15.5094 3.74539 16.6981 5.26686C17.8868 6.78833 18.5221 8.66917 18.4994 10.5998C18.4767 12.5305 17.7974 14.3959 16.5733 15.889C15.7766 16.8608 14.7744 17.6438 13.6387 18.1818C12.5031 18.7197 11.2623 18.9992 10.0057 19ZM10.0057 3.13334C8.54868 3.13334 7.12441 3.56539 5.91297 4.37485C4.70153 5.1843 3.75733 6.33482 3.19976 7.6809C2.6422 9.02698 2.49631 10.5082 2.78056 11.9372C3.0648 13.3662 3.76641 14.6788 4.79665 15.709C4.92053 15.8329 5.0485 15.952 5.18026 16.0663L6.44788 14.6143C7.34332 13.5886 8.63843 13 10 13C11.3616 13 12.6567 13.5886 13.5521 14.6143L14.8246 16.0718C15.3217 15.6419 15.7617 15.1451 16.1308 14.5927C16.9403 13.3813 17.3723 11.957 17.3723 10.5C17.3723 8.54624 16.5962 6.6725 15.2147 5.29098C13.8332 3.90947 11.9594 3.13334 10.0057 3.13334ZM10 12C11.933 12 13.5 10.433 13.5 8.5C13.5 6.567 11.933 5 10 5C8.067 5 6.5 6.567 6.5 8.5C6.5 10.433 8.067 12 10 12Z",
    fill: "#556447"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconSm);
export default __webpack_public_path__ + "static/media/user-icon-sm.7ccab722bda2955170c0168b998ee6b5.svg";
export { ForwardRef as ReactComponent };